// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core';
import {getImageUrl} from '../../../../../utils/image_provider';
import withoutImage from '../../../../../assets/img/withoutImage.png';
import {colors} from '../../../../../assets/styles/colors';

import type {SinglePromotion} from '../../../../../entities';

type Props = {
  promotion: SinglePromotion,
};

const useStyles = makeStyles(theme => ({
  categoryContent: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  leftSection: {
    marginLeft: '12px',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '8px',
    },
  },
  rightSection: {
    display: 'flex',
    marginRight: '12px',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      marginRight: '8px',
    },
    '& .MuiIconButton-root': {
      padding: '6px',
    },
    '& .MuiIconButton-root:hover': {
      padding: '6px',
    },
  },
  horizontalDivider: {
    width: 2,
    height: '35px',
    backgroundColor: '#D4D4DD',
    margin: 'auto 12px',
  },
  itemName: {
    color: colors.grey800,
    fontSize: '16px',
    lineHeight: '24px',
    marginLeft: '1.5rem',
  },
  noImg: {
    width: '48px',
    marginLeft: '8px',
    padding: '14px',
    height: 'auto',
    borderRadius: '8px',
    border: '1.5px dashed #B8B8C7',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0px',
    },
  },
  itemImg: {
    width: '48px',
    marginLeft: '8px',
    height: 'auto',
    borderRadius: '8px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0px',
    },
  },
  trashIcon: {
    color: '#E54D7B',
    float: 'right',
    cursor: 'pointer',
  },
  editIcon: {
    color: '#717190',
    float: 'right',
    cursor: 'pointer',
  },
  iconExpandSubcategories: {
    padding: '0!important',
  },
}));

export default function PromotionRow(props: Props) {
  const {promotion} = props;
  const classes = useStyles();

  return (
    <div className={classes.categoryContent}>
      <div className={classes.leftSection}>
        <img
          className={
            promotion.promotionSmallImageId || promotion.promotionImageId
              ? classes.itemImg
              : classes.noImg
          }
          src={
            promotion.promotionSmallImageId
              ? getImageUrl(promotion.promotionSmallImageId)
              : promotion.promotionImageId
              ? getImageUrl(promotion.promotionImageId)
              : withoutImage
          }
          alt="SinglePromotion"
        />
        <span className={classes.itemName}>{promotion.name}</span>
      </div>
    </div>
  );
}

PromotionRow.propTypes = {
  promotion: PropTypes.object,
};
